/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment'
import { BaseMasterData } from '../models/common/base-master-data.model';
import { APIResponseWrapper } from '../models/common/api-response-wrapper';
import { Country } from '../models/common/country.model';
import { City } from '../models/common/city.model';
import { Length } from '../models/meta-params/length';
import { LocaleService } from '../i18n/locale.service';

@Injectable()
export class BaseMasterDataService {

    restApiUrl: string;

    constructor(private http: HttpClient, private localeService: LocaleService) {
        this.restApiUrl = `${environment.restApiUrl}`;
    }

    getBaseMasterData(cultureCode?: string) {
        const culture = this.resolveCultureCode(cultureCode);
        return this.http.get<APIResponseWrapper<BaseMasterData>>(`${this.restApiUrl}shared-endpoint/base-master?cultureCode=${culture}`);
    }

    getCountries(cultureCode?: string) {
        const culture = this.resolveCultureCode(cultureCode);
        return this.http.get<Country[]>(`${this.restApiUrl}shared-endpoint/countries?cultureCode=${culture}`);
    }

    getCities(cultureCode?: string, countryId?: number): Observable<City[]> {
        // Cities are intentionally country-scoped. Never request the full world
        // city directory from the API.
        if (!countryId) {
            return of([]);
        }
        const culture = this.resolveCultureCode(cultureCode);
        const countryParam = `&countryId=${countryId}`;
        return this.http.get<City[]>(`${this.restApiUrl}shared-endpoint/cities?cultureCode=${culture}${countryParam}`);
    }

    getLengths(cultureCode?: string) {
        const culture = this.resolveCultureCode(cultureCode);
        return this.http.get<Length[]>(`${this.restApiUrl}shared-endpoint/lengths?cultureCode=${culture}`);
    }

    private resolveCultureCode(requestedCulture?: string): string {
        // Existing callers pass en-US explicitly. Treat that as the default,
        // not as a request to bypass the user's selected language.
        if (!requestedCulture || requestedCulture.toLowerCase() === 'en-us') {
            return this.localeService.apiCultureCode();
        }
        if (requestedCulture.toLowerCase() === 'ar' || requestedCulture.toLowerCase() === 'ur') {
            return this.localeService.cultureCode(requestedCulture);
        }
        return requestedCulture;
    }
    
}
